import {
  NavigationListItem,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
  navigationMenuTriggerStyle,
  NavigationMenu as NavigationMenuUI,
} from '@/components/atoms/navigation-menu'
import { cn } from '@/lib/utils'
import { routes } from '@/shared/routes'
import Link from 'next/link'
import { navigationMenuProductsMock } from '../../../shared/products'

type NavigationMenuDesktopProps = {
  className: string
}

export function NavigationMenuDesktop({
  className,
}: NavigationMenuDesktopProps) {
  return (
    <NavigationMenuUI className={cn('gap-16', className)}>
      <NavigationMenuList className="">
        <NavigationMenuItem>
          <Link href="/#" legacyBehavior passHref aria-label="Home link">
            <NavigationMenuLink className={navigationMenuTriggerStyle()}>
              Início
            </NavigationMenuLink>
          </Link>
        </NavigationMenuItem>
        <NavigationMenuItem>
          <NavigationMenuTrigger>Produtos</NavigationMenuTrigger>
          <NavigationMenuContent
            className="z-[100] data-[state=closed]:hidden"
            forceMount={true}
          >
            <ul className="grid w-[400px] gap-3 p-4 md:w-[500px] md:grid-cols-2 lg:w-[600px] bg-background">
              {navigationMenuProductsMock?.map((product) => (
                <div
                  key={product.title}
                  className="flex items-center gap-1 hover:bg-accent rounded-lg p-1"
                >
                  <div className="flex items-center justify-center w-full max-w-[60px] max-h-[60px] h-full rounded-lg bg-gray-100">
                    {product.shortLogo}
                  </div>
                  <NavigationListItem title={product.title} href={product.href}>
                    {product.description}
                  </NavigationListItem>
                </div>
              ))}
            </ul>
          </NavigationMenuContent>
        </NavigationMenuItem>

        <NavigationMenuItem>
          <Link
            href={routes.BLOG}
            legacyBehavior
            passHref
            aria-label="Blog link"
          >
            <NavigationMenuLink className={navigationMenuTriggerStyle()}>
              Blog
            </NavigationMenuLink>
          </Link>
        </NavigationMenuItem>
        <NavigationMenuItem>
          <Link
            href={routes.ABOUT_US}
            legacyBehavior
            passHref
            aria-label="Sobre nos link"
          >
            <NavigationMenuLink className={navigationMenuTriggerStyle()}>
              Sobre nós
            </NavigationMenuLink>
          </Link>
        </NavigationMenuItem>
        <NavigationMenuItem>
          <Link
            href={'https://ajuda.treeunfe.com.br'}
            legacyBehavior
            passHref
            aria-label="Ajuda"
          >
            <NavigationMenuLink className={navigationMenuTriggerStyle()}>
              Ajuda
            </NavigationMenuLink>
          </Link>
        </NavigationMenuItem>
      </NavigationMenuList>
    </NavigationMenuUI>
  )
}
